import React, { useState, useEffect, useContext } from 'react';
import { UserContext } from './UserProvider';
import { userAxios, setupAxiosInterceptors } from '../userAxios';

export const ModalContext = React.createContext();

const API_URL = process.env.REACT_APP_API_URL;

const ModalProvider = ({ children }) => {
  const { token, handleInvalidToken } = useContext(UserContext);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    setupAxiosInterceptors(handleInvalidToken);
  }, [handleInvalidToken]);

  const getResizePreference = async () => {
    try {
      const response = await userAxios.get(`${API_URL}/profile/preferences`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const newPreference = response.data.isExpanded === 'true';
      setIsExpanded(newPreference);
    } catch (error) {
      console.error('Error fetching resize preference:', error);
    }
  };

  const setResizePreference = async (newPreference) => {
    try {
      setIsExpanded(newPreference);
      await userAxios.put(
        `${API_URL}/profile/preferences`,
        { isExpanded: newPreference.toString() },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (error) {
      console.error('Error updating resize preference:', error);
    }
  };

  return (
    <ModalContext.Provider
      value={{
        isExpanded,
        setIsExpanded,
        getResizePreference,
        setResizePreference,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
